import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import {
   AccordionBody,
   AccordionHeader,
   AccordionItem,
   UncontrolledAccordion,
   Col,
   Container,
   Row,
} from "reactstrap"

import { GetTrailerEquipmentItems } from "api/api.service"
import { Loader } from "components/Loader"
import { ConfiguratorStatus } from "constants"
import ImageGallery from "pages/Configurator/CommonUI/ImageGallery/ImageGallery"
import { ConfiguratorCustomizationItemSelectionType } from "constants"
import ItemCard from "pages/Configurator/CommonUI/ItemCard/ItemCard"

const Equipments = () => {
   let { trailerId } = useParams()
   const [equipmentItemsData, setEquipmentItemsData] = useState([])
   const [loading, setLoading] = useState(false)

   useEffect(() => {
      getEquipmentItems()
   }, [trailerId])

   const getEquipmentItems = async () => {
      try {
         setLoading(true)
         let res = await GetTrailerEquipmentItems({
            trailerId: trailerId,
            limit: -1,
         })
         setEquipmentItemsData(res)
      } catch (error) {
      } finally {
         setLoading(false)
      }
   }

   if (loading) {
      return <Loader />
   }

   if (equipmentItemsData.total < 1) {
      return (
         <div className="d-flex justify-content-center align-items-center">
            <h2 className="p-4">No Data</h2>
         </div>
      )
   }

   return (
      <UncontrolledAccordion defaultOpen={0} className="my-4">
         {equipmentItemsData?.data?.map((equipmentItem, ind) => (
            <AccordionItem key={ind}>
               <AccordionHeader targetId={ind}>
                  <div className="d-flex justify-content-between w-100">
                     <div className="accordion-title-container d-flex gap-4">
                        <h4 className="accordion-title-blue  p-0 m-0">
                           {equipmentItem?.name}
                        </h4>
                        <h4 className="accordion-title-black p-0 m-0">
                           ${equipmentItem.price}
                        </h4>

                        <div
                           className={`configurator-status ${ConfiguratorStatus.getLabelClass(
                              equipmentItem.status
                           )}`}
                        >
                           <span>
                              {ConfiguratorStatus.getDisplayTextKey(
                                 equipmentItem.status
                              )}
                           </span>
                        </div>
                     </div>
                  </div>
               </AccordionHeader>
               <AccordionBody accordionId={ind}>
                  {equipmentItem.subTypePropertyVariations.length ? (
                     <div className="my-2">
                        <h4 className="accordion-title-black">
                           <h4 className="accordion-title-black">
                              Variations:{" "}
                              {ConfiguratorCustomizationItemSelectionType.getDisplayTextKey(
                                 equipmentItem.selectionType
                              )}
                           </h4>
                        </h4>
                        {equipmentItem?.subTypePropertyVariations?.length ? (
                           <Container fluid={true} className="p-0 mt-2">
                              <Row>
                                 {equipmentItem.subTypePropertyVariations?.map(
                                    (item, index) => (
                                       <Col
                                          key={index}
                                          xs="12"
                                          md="6"
                                          className="mb-3"
                                       >
                                          <ItemCard
                                             price={item?.price}
                                             name={item?.name}
                                             image={
                                                item?.images[0]?.media?.path
                                             }
                                             isDefault={item?.isDefault}
                                          />
                                       </Col>
                                    )
                                 )}
                              </Row>
                           </Container>
                        ) : null}
                     </div>
                  ) : (
                     <div className="mt-2">
                        <h4 className="accordion-title-black">
                           Default Inventory
                        </h4>
                        <small>
                           {equipmentItem?.item?.itemName}
                           <span className="mx-2">-</span>
                           <strong>Qty:</strong> {equipmentItem?.itemQuantity}
                        </small>
                     </div>
                  )}
               </AccordionBody>
            </AccordionItem>
         ))}
      </UncontrolledAccordion>
   )
}

export default Equipments
